<template>
    <header class="bubble-header"><slot/></header>
</template>
<script>
export default {
  name: 'BubbleHeader'
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.bubble-header {
  color: $black-color-1;
  font-weight: 600;
}
</style>